import React from "react";
import HerNotes from "@/components/HerNotes";

export default function HerSpacePage() {
  return <HerNotes />;
}
